// src/redux/slices/auditLogsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchSystemAuditLogsService,
  fetchAllCarePlanAuditLogs,
  fetchBuilderAuditLogsService,
  fetchUnifiedAuditLogsService,
  logSystemEventService,
} from "../../services/dashboardServices";

export const fetchSystemLogs = createAsyncThunk(
  "auditLogs/fetchSystem",
  async ({ page = 1, pageSize = 12, search = "", date_from, date_to }) =>
    fetchSystemAuditLogsService(page, pageSize, search, date_from, date_to)
);

export const fetchCarePlanLogs = createAsyncThunk(
  "auditLogs/fetchCarePlan",
  async ({ page = 1, pageSize = 12, search = "", date_from, date_to }) =>
    fetchAllCarePlanAuditLogs(page, pageSize, search, date_from, date_to)
);

export const fetchBuilderLogs = createAsyncThunk(
  "auditLogs/fetchBuilder",
  async ({ page = 1, pageSize = 12, search = "", date_from, date_to }) =>
    fetchBuilderAuditLogsService(page, pageSize, search, date_from, date_to)
);

export const fetchUnifiedLogs = createAsyncThunk(
  "auditLogs/fetchUnified",
  async ({ page = 1, pageSize = 12, search = "", date_from, date_to }) =>
    fetchUnifiedAuditLogsService(page, pageSize, search, date_from, date_to)
);

export const logSystemEvent = createAsyncThunk(
  "auditLogs/logSystemEvent",
  async (actionText) => {
    const response = await logSystemEventService(actionText);
    return response;
  }
);

const makeState = () => ({
  data: [],
  loading: false,
  loaded: false,
  error: null,
});
const initialState = {
  system: makeState(),
  carePlan: makeState(),
  builder: makeState(),
  all: makeState(),
};

const slice = createSlice({
  name: "auditLogs",
  initialState,
  extraReducers: (builder) => {
    const add = (thunk, key) => {
      builder
        .addCase(thunk.pending, (state) => {
          state[key].loading = true;
          state[key].error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state[key].loading = false;
          state[key].loaded = true;
          state[key].data = action.payload; // ← Store the fetched logs!
        })
        .addCase(thunk.rejected, (state, action) => {
          state[key].loading = false;
          state[key].error = action.error.message;
        });
    };

    add(fetchSystemLogs, "system");
    add(fetchCarePlanLogs, "carePlan");
    add(fetchBuilderLogs, "builder");
    add(fetchUnifiedLogs, "all");
  },
});

export default slice.reducer;
